import AppDialog from ".";

interface Props {
  title: string;
  description: string;
  isOpen: boolean;
  onClose(isOpen: boolean): void;
  className?: string;
  onProceed(): void;
}

const Confirm = (props: Props) => {
  return (
    <AppDialog
      title={props.title}
      onClose={props.onClose}
      isOpen={props.isOpen}
      className={props.className}
      size="sm"
    >
      <p className="text-dark dark:text-light mb-6">{props.description}</p>
      <div className="flex justify-end">
        <button className="border rounded border-purple-1 text-dark dark:text-white py-1 px-4 mr-4" onClick={() => props.onClose(false)}>Cancel</button>
        <button
          className="rounded bg-red-500 text-white py-1 px-4"
          onClick={() => {
            props.onProceed();
            props.onClose(false);
          }}
        >
          Delete
        </button>
      </div>
    </AppDialog>
  );
};

export default Confirm;
